const DEFAULTS: any = {
    martFontFamily: 'Segoe UI',
    martBG: '#333',
    martShowHeader: true,
    martHeaderBG: '#222',
    martHeaderFontSize: '12px',
    martHeaderPadding: {x: '10px', y: '3px'},
    martHeaderFG: '#fff',
    martActiveCategoryIndicatorColor: '#4220b1',
    martCategoryFontSize: '18px',
    martCategoryColor: '#fff',
    martCategoryColorActive: '#4220b1',
    martActiveCategoryIndicatoHeight: '4px',
    martWidth: '100%',
    martHeight: '30vh',
    martBorderRadius: '5px',
    martEmojiFontSize: '120%',
    martEmojiPadding: {x: '40px', y: '40px'},
    martFooterFG: '#fff',
    martFooterBG: '#222',
    martFooterFontSize: '12px',
    martFooterPadding: {x: '10px', y: '3px'},
    martShowFooter: true,
    maxRecentEmoji: 36,
    recentEmojiStoreKey: 'ngx-emoji-picker-recent-emo-store',
    emojiNotFoundText: 'No results ;)',
    searchEmojiPlaceholderText: 'Search',
    martEmojiNotFoundFG: '#888',
    martSearchBoxStyle: {
      FGcolor: '#333',
      BGcolor: 'transparent',
      borderColor: '#ccc',
      placeHolderColor: '#777',
      borderRadius: '30px',
    }
};

export default DEFAULTS;
